(function () {
  function loadSwiper(callback) {
    if (typeof Swiper !== "undefined") {
      callback();
      return;
    }

    const existing = document.querySelector('script[data-el-swiper="true"]');
    if (existing) {
      if (typeof Swiper !== "undefined" || existing.dataset.loaded === "true") {
        callback();
        return;
      }
      existing.addEventListener("load", callback, { once: true });
      return;
    }

    if (!document.querySelector('link[data-el-swiper-css="true"]')) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
      link.dataset.elSwiperCss = "true";
      document.head.appendChild(link);
    }

    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
    script.dataset.elSwiper = "true";
    script.addEventListener(
      "load",
      () => {
        script.dataset.loaded = "true";
        callback();
      },
      { once: true }
    );
    document.body.appendChild(script);
  }

  function cleanupSliderDom(slider) {
    if (!slider) return;
    slider.querySelectorAll(".swiper-slide-duplicate").forEach((el) => el.remove());
    const wrapper = slider.querySelector(".swiper-wrapper");
    if (wrapper) {
      wrapper.removeAttribute("style");
    }
    slider.querySelectorAll(".swiper-slide").forEach((slide) => {
      slide.removeAttribute("style");
      slide.classList.remove(
        "swiper-slide-active",
        "swiper-slide-next",
        "swiper-slide-prev",
        "swiper-slide-fully-visible",
        "swiper-slide-visible"
      );
    });
  }

  function destroySwiper(section) {
    const slider = section.querySelector(".el-testimonials__slider");
    if (section._elTestimonialsSwiper) {
      section._elTestimonialsSwiper.destroy(true, true);
      delete section._elTestimonialsSwiper;
    }
    cleanupSliderDom(slider);
  }

  function getMode() {
    const width = window.innerWidth;
    if (width <= 580) return "mobile";
    if (width <= 991) return "tablet";
    return "desktop";
  }

  function slideCount(swiper) {
    const originals = swiper.el.querySelectorAll(
      ".swiper-slide:not(.swiper-slide-duplicate)"
    );
    return Math.max(originals.length, 1);
  }

  function updateProgress(swiper, section) {
    const fill = section.querySelector(".el-testimonials__progress-fill");
    if (!fill) return;
    const total = slideCount(swiper);
    const ratio = ((swiper.realIndex % total) + 1) / total;
    fill.style.width = `${ratio * 100}%`;
  }

  function initTestimonials(section) {
    const slider = section.querySelector(".el-testimonials__slider");
    const prev = section.querySelector(".el-testimonials__arrow--prev");
    const next = section.querySelector(".el-testimonials__arrow--next");
    if (!slider || typeof Swiper === "undefined") return;

    const mode = getMode();
    if (section._elTestimonialsMode === mode && section._elTestimonialsSwiper) {
      section._elTestimonialsSwiper.update();
      updateProgress(section._elTestimonialsSwiper, section);
      return;
    }

    destroySwiper(section);
    section._elTestimonialsMode = mode;

    const isMobile = mode === "mobile";
    const isTablet = mode === "tablet";
    const originalCount = slider.querySelectorAll(".swiper-slide").length;
    const desktopPerView = isTablet ? 2 : 3;

    // Swiper 11 needs enough slides relative to slidesPerView for stable loop.
    const canLoop = isMobile
      ? originalCount >= 3
      : originalCount >= desktopPerView + 1;

    const config = {
      spaceBetween: isMobile ? 8 : isTablet ? 12 : 32,
      speed: 450,
      watchOverflow: false,
      observer: true,
      observeParents: true,
      initialSlide: 0,
      on: {
        init(swiper) {
          if (canLoop && typeof swiper.slideToLoop === "function") {
            swiper.slideToLoop(0, 0, false);
          }
          updateProgress(swiper, section);
        },
        slideChange(swiper) {
          updateProgress(swiper, section);
        },
      },
    };

    if (isMobile) {
      Object.assign(config, {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 8,
        loop: canLoop,
        loopAdditionalSlides: canLoop ? 1 : 0,
        loopPreventsSliding: false,
        allowTouchMove: true,
      });
    } else {
      Object.assign(config, {
        slidesPerView: desktopPerView,
        centeredSlides: false,
        loop: canLoop,
        rewind: !canLoop && originalCount > 1,
        loopAdditionalSlides: canLoop ? 1 : 0,
        loopPreventsSliding: false,
        navigation:
          prev && next
            ? {
                prevEl: prev,
                nextEl: next,
              }
            : undefined,
      });
    }

    section._elTestimonialsSwiper = new Swiper(slider, config);
  }

  function boot(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll("[data-el-testimonials]").forEach((section) => {
      initTestimonials(section);
    });
  }

  let resizeTimer;
  window.addEventListener(
    "resize",
    () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => boot(), 150);
    },
    { passive: true }
  );

  loadSwiper(() => boot());

  document.addEventListener("shopify:section:load", (event) => {
    loadSwiper(() => boot(event.target));
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const section =
      event.target.querySelector?.("[data-el-testimonials]") || event.target;
    const target = section?.matches?.("[data-el-testimonials]")
      ? section
      : section?.querySelector?.("[data-el-testimonials]");
    if (target) destroySwiper(target);
  });
})();
